module.exports = __webpack_public_path__ + "img/GENERAL-FRONX-BOOSTERGREEN-1.cdc33e4d.jpg";